import React from "react";

import SubBoxWrapper from "../../wrapper/SubBoxWrapper";

import ListItem from "./ListItem";

function CurrentStar({ info, menuLink, titleText, currentStarList, menuTypeCode, drawCd }) {
    return (
        <SubBoxWrapper
            info={info}
            titleText={titleText}
            menuLink={menuLink}
            menuTypeCode={menuTypeCode}
            customClassName={"currentSituation clear"}
            drawCd={drawCd}
        >
            <div className="csSub clear">
                {currentStarList?.map((info, idx) => (
                    <ListItem key={idx} title={info.NAME} count={info.CNTT} info={info} />
                ))}
            </div>
        </SubBoxWrapper>
    );
}

export default CurrentStar;
